export { InputCheckbox } from './InputCheckbox.js';
//# sourceMappingURL=index.js.map
